




















import Vue from 'vue';
import { StoreConstants, WorkflowJobButtonModel } from '@/types';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'WorkflowButtons',
  props: {
    buttons: {
      type: Array,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    },
    isWorkflowJobLocked: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentButtonId: ''
    };
  },
  computed: {
    ...mapGetters(StoreConstants.WorkflowJob.ModuleName, [StoreConstants.WorkflowJob.Getters.IsTabProcessing])
  },
  methods: {
    getButtonTextSlotName(button: WorkflowJobButtonModel): string {
      return (
        button.caption
          .trim()
          .replace(' ', '-')
          .toLowerCase() + 'ButtonText'
      );
    },
    buttonClicked(this: any, event: any, button: WorkflowJobButtonModel) {
      this.currentButtonId = button.id;
      event.target.blur();
      this.$emit(
        `${button.caption
          .trim()
          .replace(' ', '-')
          .toLowerCase()}-button-clicked`,
        button
      );
    },
    showLoading(this: any, button: WorkflowJobButtonModel): boolean {
      return this.isLoading && this.currentButtonId === button.id;
    },
    isButtonDisabled(this: any, button: WorkflowJobButtonModel) {
      if (button.caption.toLowerCase() === 'close') {
        return this.isLoading || this[StoreConstants.WorkflowJob.Getters.IsTabProcessing];
      } else {
        return this.isWorkflowJobLocked || ((!button.isEnabled || this.isLoading || this[StoreConstants.WorkflowJob.Getters.IsTabProcessing]) && button.processingAction !== null);
      }
    }
  }
});
